import { Route as rootRoute } from "./routes/__root";
import { Route as indexRoute } from "./routes/index";
import { Route as loginRoute } from "./routes/login";
import { Route as authCallbackRoute } from "./routes/auth-callback";
import { Route as authenticatedRoute } from "./routes/_authenticated";
import { Route as dashboardRoute } from "./routes/_authenticated/dashboard";
import { Route as dashboardIndexRoute } from "./routes/_authenticated/dashboard/index";
import { Route as meetingsRoute } from "./routes/_authenticated/dashboard/meetings";
import { Route as libraryRoute } from "./routes/_authenticated/dashboard/library";
import { Route as projectRoute } from "./routes/_authenticated/dashboard/projects/$projectId";
import { Route as newProjectRoute } from "./routes/_authenticated/dashboard/new-project";

const dashboardChildren = dashboardRoute.addChildren([
  dashboardIndexRoute,
  meetingsRoute,
  libraryRoute,
  projectRoute,
  newProjectRoute,
]);

const authenticatedChildren = authenticatedRoute.addChildren([
  dashboardChildren,
]);

export const routeTree = rootRoute.addChildren([
  indexRoute,
  loginRoute,
  authCallbackRoute,
  authenticatedChildren,
]);
